import { DISPLAY_MODE } from '../../constant'

/** *****************************************************************************
 * Provides utilities for managing practitioner tags
 */

/**
 * @param props
 * @return True if props indicate that the display mode is SMART
 */
export const isSmartDisplay = (props: Readonly<any>): boolean => (
  props &&
  !!props.mode &&
  props.mode.toUpperCase() === DISPLAY_MODE.SMART
)

/**
 * @param props
 * @return True if props indicate that the display mode is EMBEDDED
 */
export const isEmbeddedDisplay = (props: { mode: string }): boolean => (
  props &&
  !!props.mode &&
  props.mode.toUpperCase() === DISPLAY_MODE.EMBEDDED
)
